export default __webpack_public_path__ + "static/math2it-161e56305c9d8a9f930d5373f5a5757a.png";